/**
 *
 * @component 用户中心/数据看板/----消息卡片组件
 *
 **/

import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import dayjs from 'dayjs';
import BaseCard from '@/components/UserCenter/BaseCard';
import { useRouterTarget } from '&/utils/customHooks';
import { SYNERGIA_TAB_STATUS } from '&/utils/baseMacro';
import { markRead } from '@/api/personCenter/message';
import BaseDrawer from '&/components/BaseDrawer';
import { useStoreState } from '&/utils/customHooks';
import { formatPhone } from '&/utils/common';
import { manegerMsgDetail } from '@/api/personCenter/message';
import './MesaggeCard.scss';

function MesaggeCard(props) {
    const { defaultValue } = props;
    const persenCenter = useStoreState('persenCenter');
    const [data, setData] = useState({});
    const [active, setActive] = useState(0);
    const [FIRST, SECOND] = [
        intl.get('userCenter.interactiveMsg'),
        intl.get('message.stewardMessage'),
    ];
    const { message = {}, steward = {} } = data || {};
    const [tabData, setTabData] = useState([
        {
            name: FIRST,
            key: 0,
        },
        {
            name: SECOND,
            key: 1,
        },
    ]);

    useEffect(() => {
        if (!data.message) return;
        setTabData([
            {
                name: `${FIRST}(${message.count})`,
                key: 0,
                unread: message.count,
            },
            {
                name: `${SECOND}(${steward.count})`,
                key: 1,
                unread: steward.count,
            },
        ]);
    }, [data]);

    useEffect(() => {
        setData(defaultValue || {});
    }, [defaultValue]);

    const history = useHistory();
    const targetMessage = () => {
        history.push('/user-center/interactive-message?tab=' + active);
    };

    const more = (
        <span onClick={targetMessage} className="native-link type--normal">
            {intl.get('base.viewMore')}
        </span>
    );

    const targetPage = useRouterTarget();

    // 点击查看
    const targetTo = (params, data) => {
        let jumpText = intl.get('userCenter.clickHere');

        if (params.url) {
            return (
                <a className="native-link" onClick={params.url}>
                    {jumpText}
                </a>
            );
        }

        const PROJECT_URL = '/user-center/project-space/scheme-detail',
            { PLANS, DRAWING } = SYNERGIA_TAB_STATUS,
            { pageTarget } = params;

        switch (pageTarget) {
            case 'order': // 会员开通/付款提醒/订单关闭：跳转订单详情
                jumpText = intl.get('base.viewDetail');
                break;
            case 'software': // 会员续费: 跳转智能设计订单  "智能设计订单已删除"
                return;
            /* jumpText = intl.get('userCenter.renew');
                break; */
            default:
                break;
        }

        const targetMethods = {
            order() {
                // 会员开通/付款提醒/订单关闭：跳转订单详情
                const { type } = params;
                const FOLDERS = ['intelligent-design', 'cloud-services'];
                targetPage({
                    pathname: `/user-center/${FOLDERS[type]}/order-detail`,
                    search: { type, id: params.orderCode },
                });
            },
            // 会员续费: 跳转智能设计订单
            // 目前企业版已删除  智能设计订单 页面  @see HDC-5881
            /*  software() {
                targetPage({
                    pathname: '/user-center/intelligent-design',
                    search: {
                        subscribe: 1,
                    },
                }); 
            },*/
            project() {
                // 项目开通/项目续费:跳转项目详情
                const { div } = params;
                const FOLDERS = ['project-detail', 'scheme-detail'];
                const TABS = [2, SYNERGIA_TAB_STATUS.INFO];
                targetPage({
                    pathname: `/user-center/project-space/${FOLDERS[div - 1]}`,
                    search: {
                        id: params.projectId,
                        tab: TABS[div - 1],
                    },
                });
            },
            projectMemberList() {
                // 项目成员列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: SYNERGIA_TAB_STATUS.MEMBERS,
                    },
                });
            },
            projectDrawing() {
                //  指定的项目施工图
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.project_id,
                        tab: DRAWING,
                        drawing_id: params.drawing_id,
                    },
                });
            },
            projectDrawingIndex() {
                //  项目施工图tab页
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.project_id,
                        tab: DRAWING,
                    },
                });
            },
            modelDetailWeb() {
                // 模型详情
                targetPage(`/model-base/material-detail/${params.modelId}`);
            },
            schedule() {
                // 进度计划列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                    },
                });
            },
            stageDetail() {
                // 【施工阶段】详情
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'DETAIL',
                    },
                });
            },
            stageCheck() {
                // 施工阶段 验收
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'CHECK',
                    },
                });
            },
            decoration() {
                // 装修待办列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'DECORATION',
                    },
                });
            },
            adjunct() {
                // 附件列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        drawer: 'ADJUNCT',
                    },
                });
            },
            additional() {
                // 增项列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        drawer: 'ADDITIONAL',
                    },
                });
            },
            patrol() {
                // 巡检列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'PATROL',
                    },
                });
            },
            moments() {
                // 施工动态列表
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: params.stageId,
                        drawer: 'MOMENTS',
                    },
                });
            },
            projectCheck() {
                // 项目验收
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: PLANS,
                        stageId: -1,
                        drawer: 'CHECK',
                    },
                });
            },
            fund() {
                // 项目款项tab
                targetPage({
                    pathname: PROJECT_URL,
                    search: {
                        id: params.projectId,
                        tab: SYNERGIA_TAB_STATUS.PAYMENT,
                    },
                });
            },
            organization() {
                // 组织架构
                targetPage({
                    pathname: '/user-center/organization',
                    search: {
                        entId: params.entId,
                        depId: params.depId,
                    },
                });
            },
        };

        const handleJump = () => {
            markAsRead([data.id], data.status);
            targetMethods[pageTarget]?.();
        };

        return (
            <a className="native-link" onClick={handleJump}>
                {jumpText}
            </a>
        );
    };

    const isHasLink = data => {
        if (!data.param1) return false;
        const PARAMS = JSON.parse(data.param1);
        if (!PARAMS) return false;
        return true;
    };

    const messageTarget = data => {
        if (!isHasLink(data)) return;
        const PARAMS = JSON.parse(data.param1);
        return targetTo(PARAMS, data);
    };

    const filterMessageList = id => {
        setData(prev => {
            const next = { ...prev };
            next.message.list = next.message.list.filter(el => {
                return el.id !== id;
            });
            return next;
        });
    };

    const markAsRead = async (ids, status) => {
        if (status === 1) return;
        filterMessageList(ids[0]);
        const [first] = ids;
        if (first === void 0) return;
        await markRead({
            ids,
        });
        persenCenter.queryUnreadAmount();
        setTabData(prev => {
            const next = [...prev];
            const nextNum = prev[0].unread > 0 ? prev[0].unread - 1 : 0;
            next[0] = {
                name: `${FIRST}(${nextNum})`,
                key: 0,
                unread: nextNum,
            };
            return next;
        });
    };

    const CONTENT1 = !message.list?.length ? (
        <Empty
            image={
                require('&/assets/img/userCenter/emptyydata-object.png').default
            }
            imageStyle={{
                height: 160,
            }}
            description={<div className="hint-message">暂无数据</div>}></Empty>
    ) : (
        message.list?.slice(0, 4).map(item => (
            <section
                className="message-card__item pointer"
                key={item.id}
                onClick={
                    !isHasLink(item)
                        ? () => {
                              markAsRead([item.id], item.status);
                          }
                        : () => {}
                }>
                <div className="message-title" title={item.content}>
                    {item.content
                        .replace(intl.get('userCenter.clickHere'), '')
                        .replace(intl.get('userCenter.clickDetail'), '')}
                    {messageTarget(item)}
                </div>

                <div className="message-date">
                    {dayjs(item.create_date || item.createDate * 1e3).format(
                        'YYYY-MM-DD HH:mm'
                    )}
                </div>
            </section>
        ))
    );

    const [visible, setVisible] = useState(false);

    const onClose = () => {
        setVisible(false);
        setData(prev => {
            const next = { ...prev };
            next.steward.list = next.steward.list.filter(el => {
                return el.id !== clickData.id;
            });
            next.steward.count = next.steward.list.length;
            return next;
        });
    };

    const [detailData, setDetailData] = useState({});
    const [clickData, setClickData] = useState({});
    const showDetail = msgItem => {
        setDetailData(msgItem);
        setClickData(msgItem);
        setVisible(true);
        manegerMsgDetail({ dop: 2, messageId: msgItem.id }).then(({ data }) => {
            setDetailData(prev => ({ ...prev, ...data.detail }));
            setTabData(prev => {
                const next = [...prev];
                const nextNum = prev[1].unread > 0 ? prev[1].unread - 1 : 0;
                next[1] = {
                    name: `${FIRST}(${nextNum})`,
                    key: 1,
                    unread: nextNum,
                };
                return next;
            });
        });
    };
    const { userInfo } = useStoreState('appStore');

    const detailDrawer = (
        <BaseDrawer
            visible={visible}
            title={intl.get('message.steward.notification')}
            bodyStyle={{
                padding: '1.875rem 3.75rem',
            }}
            width="47.5rem"
            destroyOnClose
            className="msg-detail"
            onClose={onClose}>
            <section className="item-block">
                <span className="msg-detail-label">
                    {intl.get('message.steward.title')}
                </span>
                {detailData.title}
            </section>
            <section className="item-block">
                <span className="msg-detail-label">
                    {intl.get('message.steward.send')}
                </span>
                {formatPhone(userInfo.username)}
            </section>
            <section className="item-block">
                <span className="msg-detail-label">
                    {intl.get('message.steward.sendTime')}
                </span>
                {detailData.createDate}
            </section>
            <section className="item-block">
                <span className="msg-detail-label">
                    {intl.get('message.steward.sendContent')}
                </span>
            </section>
            <article className="item-article"> {detailData.content}</article>
        </BaseDrawer>
    );

    const CONTENT2 = !steward.list?.length ? (
        <Empty
            image={
                require('&/assets/img/userCenter/emptyydata-object.png').default
            }
            imageStyle={{
                height: 160,
            }}
            description={<div className="hint-message">暂无数据</div>}></Empty>
    ) : (
        steward.list?.slice(0, 4).map(item => (
            <section
                className="message-card__item pointer"
                key={item.id}
                onClick={() => showDetail(item)}>
                <div className="message-title text-no-wrap" title={item.title}>
                    {item.title}
                    {active === 1 && messageTarget(item)}
                </div>

                <div className="message-date">
                    {dayjs(item.create_date || item.createDate * 1e3).format(
                        'YYYY-MM-DD HH:mm'
                    )}
                </div>
            </section>
        ))
    );

    return (
        <BaseCard
            className="mesagge-card"
            tabsProps={{ onChange: setActive }}
            tabs={tabData}
            headerExtra={more}>
            {[CONTENT1, CONTENT2][active]}
            {detailDrawer}
        </BaseCard>
    );
}

export default MesaggeCard;
